import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import DetailService from '@/core/services/detail.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class SupportDetailComponent extends Vue {

  detailService: any = new DetailService();
  sidebarService: any = new SidebarService();
  support_id: any = [];
  logInModal: boolean = false;
  showModal: boolean = false;
  genericErr: any = [];
  supportList: any = [];
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  name: string = "";
  phone: string = "";
  message: string = "";
  subject: string = "";
  createdAt: string = "";
  updatedAt: string = "";

  mounted (){
    const _ = this;
    _.getBySupport();
    _.filterDate();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  getBySupport(){
    const _ = this;
    _.support_id = location.href.split("/");
    _.support_id = _.support_id[5];
    _.isLoading = true;
    _.detailService.getBySupport(_.support_id).then((data: any) => {
      console.log(data);
      console.log(_.support_id)
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.name = data["data"].ticket.name;
      _.phone = data["data"].ticket.phone;
      _.message = data["data"].ticket.message;
      _.subject = data["data"].ticket.subject;
      _.createdAt = data["data"].ticket.createdAt;
      _.updatedAt = data["data"].ticket.updatedAt;
      console.log(data)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }
}
